<bizz-modal modalSize="lg" [headerTemplate]="headerTemplateRef" [contentTemplate]="contentTemplateRef"
            [footerTemplate]="footerTemplateRef"></bizz-modal>

<ng-template #headerTemplateRef>
    <div class="modal-header">
        <h1 class="mb-5 text-center font-title text-xl font-bold text-default">
            {{ "InstanceHasAlreadyBeenLinked" | translate }}</h1>
        <hr class="border-box m-auto my-5 h-0 w-full border-t-2 border-divider">

    </div>
</ng-template>
<ng-template #contentTemplateRef>
    <div class="gap-4">
        <p>
            {{ "AreYouSureYouWantToLink" | translate }}
        </p>

        <div class="flex gap-2 w-full">
            <label class="flex-1">
                {{ "SelectedInstanceData" | translate }}
            </label>
            <div class="flex-1">
                @if (displayProperties) {
                    <ul>
                        @for (prop of displayProperties; track $index) {
                            <li>{{ prop }}</li>
                        }
                    </ul>
                }

            </div>
        </div>

        <div class="flex gap-2 w-full">
            <label class="flex-1">
                {{ "LinkedInstancesID" | translate }}
            </label>
            <div class="flex-1">
                <ul>
                    @for (id of data.instance.LinkedToParentVersions; track $index) {
                        <li>{{ id }}</li>
                    }
                </ul>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #footerTemplateRef>
    <div class="modal-buttons">
        <div class="flex flex-row justify-end gap-4 text-center">
            <button class="default"
                    (click)="dialogRef.close()">
                {{ 'Cancel' | translate }}
            </button>
            <button class="save rounded-md"
                    (click)="link()">
                {{ 'Link' | translate }}
            </button>

        </div>

    </div>
</ng-template>
